
import { Component, Vue } from "vue-property-decorator";
import { Bar } from 'vue-chartjs/legacy';
import { dataVisualizationModule } from "@/store";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale
} from 'chart.js';

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale);

@Component({
  components: {
    Bar
  }
})
export default class PatientChart extends Vue {
  chartDatas = {
    labels: [] as string[],
    datasets: [
      {
        label: "",
        backgroundColor:  ['#ffac1c',
          '#ff6f00',
          '#ffd700',
          '#ff8c00',
          '#ffa07a',
          '#ffc107'],
        data: [] as number[],
      }
    ]
  };

  chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false
      }
    },
    scales: {
      y: {
        ticks: {
          precision: 0, // no decimals
          stepSize: 1,  // force step size of 1
          callback: function (value: number) {
            return Number.isInteger(value) ? value : '';
          }
        },
        beginAtZero: true
      }
    }
  };

  get rawChartData(): any[] {
    return dataVisualizationModule.getChartData("patientCount");
  }

  get chartDataAvailable(): boolean {
    return this.chartDatas.labels.length > 0 && this.chartDatas.datasets[0].data.length > 0;
  }

  async mounted() {
    try {
      await dataVisualizationModule.loadAll("patientCount");

      const rawData = this.rawChartData;
      const labels = rawData.map((entry: any) => entry.Gender);
      const data = rawData.map((entry: any) => entry.PatientCount);

      this.chartDatas = {
        labels,
        datasets: [
          {
            label: "",
            backgroundColor:  ['#ffac1c',
              '#ff6f00',
              '#ffd700',
              '#ff8c00',
              '#ffa07a',
              '#ffc107'],
            data
          }
        ]
      };
    } catch (e) {
      console.error("Failed to load chart data", e);
    }
  }
}
